/*
 * Status tags (ADR 0028): coloured, and always a word. Teal means it went well, amber that it
 * is waiting, primary blue that it is in progress. Colour is never the only signal: the shape
 * still tells states apart in greyscale (a tinted fill, an outline or a solid fill, with a
 * small dot that is hollow for not started, filled for done or needs attention, or absent).
 * Words use the dark text shades, so every pair is at least 4.5:1.
 */
.tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-tag);
  background: var(--status-neutral-bg);
  color: var(--status-neutral-fg);
  font: var(--t-micro);
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
}

.tag::before {
  display: none;
  flex: none;
  width: 7px;
  height: 7px;
  border: 1.5px solid currentcolor;
  border-radius: 50%;
  content: '';
}

/* Waiting, pending, not started: amber tint, amber outline, a hollow dot. */
.tag[data-state='pending'] {
  border-color: var(--color-warning);
  background: var(--status-warning-bg);
  color: var(--status-warning-fg);
}

.tag[data-state='pending']::before {
  display: block;
  border-color: var(--color-warning);
}

/* In progress, active: the one solid tag, in primary blue. */
.tag[data-state='active'] {
  border-color: var(--brand);
  background: var(--brand);
  color: var(--on-brand);
}

/* Finished, paid, approved, connected: teal tint, no outline, a filled teal dot. */
.tag[data-state='done'] {
  border-color: var(--status-success-bg);
  background: var(--status-success-bg);
  color: var(--status-success-fg);
}

.tag[data-state='done']::before {
  display: block;
  border-color: var(--color-success);
  background: var(--color-success);
}

/* Held, needs review, needs attention: white with an amber outline and a filled amber dot. */
.tag[data-state='attention'] {
  border-color: var(--color-warning);
  background: var(--paper);
  color: var(--status-warning-fg);
}

.tag[data-state='attention']::before {
  display: block;
  border-color: var(--color-warning);
  background: var(--color-warning);
}

/* Declined, failed, rejected: neutral fill, dark outline and text. Never the danger red. */
.tag[data-state='failed'] {
  border-color: var(--status-error-fg);
  background: var(--status-error-bg);
  color: var(--status-error-fg);
}

/* Clinical danger only: white, with danger text and border. */
.tag[data-state='danger'] {
  border-color: var(--danger);
  background: var(--paper);
  color: var(--danger);
}
